import { computedFrom, autoinject } from 'aurelia-framework';
import { WebApiService } from '../services/web-api-service';

@autoinject()
export class SecurityService {

    constructor(private api: WebApiService) {
    }

    private readyPromise: any;
    init() {
        if (this.readyPromise)
            return this.readyPromise;

        return this.readyPromise = this.api.get("Login", "GetCurrentUser")
            .then((result) => {
                var userInfo = JSON.parse(result.response);
                this.user = userInfo.user;
                this.roles = userInfo.roles;
                this.groups = userInfo.groups;
                this.isDivisionUser = !!(this.user.millCodes && this.user.millCodes.length);
                this.isReady = true;
                this.isAuthenticated = !!(this.user && this.user.userName);
            });
    }

    //TODO: This logic is incorrect and should be more diligent in determining the flag, and considering the usage implications.
    // NOTE: Furthermore, a user could start with "%waad" and be SSO for another applicaiton, and username-password for CMP
    @computedFrom("user.userName")
    get isSSOUser(): boolean {
        if (this.user && this.user.userName && this.user.userName.toLocaleLowerCase().indexOf("@nucor.com") > -1) {
            return true;
        }
        return false;
    }

    isReady: boolean = false;
    isDivisionUser: boolean;
    user: { id: string, userName: string, millCodes: string[], active: boolean, emailAddress: string, fullName: string, firstName: string, lastName:string};
    roles: Array<any> = [];
    groups: Array<string> = []; // group IDs
    roleMap={};
    hasRole(role) {
        if (this.roleMap[role] == undefined) {
            this.roleMap[role] = this._hasRole(role);
        }
        return this.roleMap[role];
    }
    _hasRole(role) {
        return !!this.roles.find(r => r.toLowerCase() == role.toLowerCase());
    }
    groupMap={};
    hasGroup(groupId) {
        if (this.groupMap[groupId] == undefined) {
            this.groupMap[groupId] = this._hasGroup(groupId);
        }
        return this.groupMap[groupId];
    }
    _hasGroup(groupId) {
        return !!this.groups.find(o => o.toLowerCase() == groupId.toLowerCase());
    }

    isAuthenticated: boolean = false;
}